/*** IMPORTS FROM imports-loader ***/
(function() {

define(['window', 'pip-events'], function(window, pipEvents) {
  function initEventListeners() {
    function getDdoImpression() {
      return window._T.pageData[0] || null;
    }

    function updateImpressionAnalyticsObject(thdAnalyticsEvent) {
      if (window._T && window._T.pageData) {
        window._T.pageData[0] = thdAnalyticsEvent;
      }
    }

    function pushInteractionAnalyticsEvent(thdAnalyticsEvent) {
      if (window.digitalData && window.digitalData.event) {
        window.digitalData.event.push(thdAnalyticsEvent);
      }
    }

    pipEvents.automotive.vehicleChanged.on(function () {
      var thdAnalyticsEvent = {
        "category": {
          primaryCategory: 'stash'
        },
        "eventInfo": {
          eventName: 'widget interaction'
        },
        "eventMode": 'stash'
      };
      pushInteractionAnalyticsEvent(thdAnalyticsEvent);
    });

    pipEvents.automotive.fitmentBadgeUpdated.on(function (type, compatibilityAndSelectedOptions) {
      var ddoImpression = getDdoImpression();
      if (ddoImpression && compatibilityAndSelectedOptions.length >= 2) {
        ddoImpression.content.widget = [{
          type: 'auto',
          value: compatibilityAndSelectedOptions[1]
        }];
        ddoImpression.product[0].productInfo.compatibility = compatibilityAndSelectedOptions[0];
        updateImpressionAnalyticsObject(ddoImpression);
      }
    });
  }

  return {
    init: function () {
      initEventListeners();
    }
  }
});

}.call(window));